import React from 'react';
import { motion } from 'framer-motion';

// Flat-lay outfit images by weather condition (brand colors: teal/green)
const weatherImages = {
  cold: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/e03c047024416e9bac00b91110cbf89da4da4ed2749ce0f02894e3577377dd8d.png',
  cool: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/e03c047024416e9bac00b91110cbf89da4da4ed2749ce0f02894e3577377dd8d.png',
  mild: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/c3e3d39f35607824d7c248f663aa7bbf2035a18a0e237959378a7426fd0d8bbf.png',
  temperate: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/c3e3d39f35607824d7c248f663aa7bbf2035a18a0e237959378a7426fd0d8bbf.png',
  warm: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/fcfbe8af901d2b63093b5b2213e26142c4625757d4ad8a514b15e7c6b0011fe5.png',
  hot: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/fcfbe8af901d2b63093b5b2213e26142c4625757d4ad8a514b15e7c6b0011fe5.png',
  rain: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/f97852156ae347f1ffd674729e2e6b75f0caa32f1bcb74ec63c93696f3443b13.png',
};

// Activity-specific images (with towel, mat, etc.)
const activityImages = {
  fitness: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/fe14e17d0144c284771079f7607c66de0b00b0d2d99d2515a3b2a6c957b92a08.png',
  mobility: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/af558b4c7b9e1f72bcbbacb19b244dfa48cb778c6a7d19070c8cb876b6dac9ee.png',
  gentle: 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/af558b4c7b9e1f72bcbbacb19b244dfa48cb778c6a7d19070c8cb876b6dac9ee.png',
};

export const heroImage = 'https://static.prod-images.emergentagent.com/jobs/f4b6a95a-7e98-4d45-9f7a-ada39d42bdee/images/33c42e714cdc2353519f63a6b4c793f7c97acfc8f5a6c32fe5b53af948625c33.png';

export function OutfitDisplay({ tempCase, isRainy = false, activity = 'general' }) {
  // Activity-specific images take priority for fitness/mobility/gentle
  const useActivityImage = activityImages[activity];
  const imgUrl = useActivityImage || (isRainy ? weatherImages.rain : (weatherImages[tempCase] || weatherImages.mild));

  return (
    <motion.div
      key={`${tempCase}-${isRainy}-${activity}`}
      className="relative w-full"
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    >
      {/* Subtle glow behind image */}
      <div
        className="absolute inset-0 blur-[60px] opacity-15 rounded-full"
        style={{
          background: tempCase === 'cold' || tempCase === 'cool'
            ? 'radial-gradient(circle, #3b82f6, transparent 70%)'
            : tempCase === 'warm' || tempCase === 'hot'
            ? 'radial-gradient(circle, #22c55e, transparent 70%)'
            : 'radial-gradient(circle, #3BADE5, transparent 70%)',
        }}
      />
      <motion.img
        src={imgUrl}
        alt="Outfit recommendation"
        className="relative z-10 w-full h-auto rounded-2xl object-cover"
        style={{ maxHeight: '480px' }}
        loading="eager"
        initial={{ y: 12, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.1 }}
      />
    </motion.div>
  );
}
